import React from 'react'

const TransactionDetail = () => {
  return (
    <div div style={{ margin: '20px 10px 20px 0px' }}>
      <div style={{ fontFamily: 'Inter Bold', marginBottom: '20px' }}>
        {' '}
        Transaction Detail
      </div>
      <div style={{ width: '100%', overflowX: 'auto' }}>
        <table
          style={{
            width: 'max-content',
            minWidth: '100%',
            marginLeft: 0,
            marginRight: 0
          }}
        >
          <tr>
            <th>Company</th>
            <th>Contact</th>
            <th>Country</th>
            <th>Company</th>
            <th>Contact</th>
            <th>Country</th>
            <th>Company</th>
            <th>Contact</th>
            <th>Country</th>
          </tr>
          <tr>
            <td>Alfreds Futterkiste</td>
            <td>Maria Anders</td>
            <td>Germany</td>
          </tr>
          <tr>
            <td>Centro comercial Moctezuma</td>
            <td>Francisco Chang</td>
            <td>Mexico</td>
          </tr>
        </table>
      </div>
    </div>
  )
}

export default TransactionDetail
